// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawer_SideDrawer__yVMeB","Open":"SideDrawer_Open__zALzX","Close":"SideDrawer_Close__2S9cu","Logo":"SideDrawer_Logo__D7Vq7"};